import { render, staticRenderFns } from "./statCard.vue?vue&type=template&id=79b81405&"
import script from "./statCard.vue?vue&type=script&lang=js&"
export * from "./statCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports